
import React, { Component } from 'react';
import './App.css';



class Name extends Component {
  render() { 
    return (
	<div className="Name">
	{this.props.name}
	</div>
	);
  }
}
class Address extends Component {
  render() { 
    return (
	<div className="Address">
	{this.props.address}
	</div>
	);
  }
}

class Phone extends Component {
  render() { 
    return (
	<div className="Phone">
	{this.props.phone}
	</div>
	);
  }
}
class Email extends Component {
  render() { 
    return (
	<div className="Email">
	{this.props.email}
	</div>
	);
  }
}

// This will be used to show top info 
// Name, Address, Phone, Email.


class ContactInfo extends Component {
   render() { 
     return (
	 <div className="ContactInfo">
	 <div className="LeftBox">
	 <Name {...this.props} />
	 <Address {...this.props} />
	 </div>
	 <div className="RightBox">
	 <Phone {...this.props} />
	 <Email {...this.props} />
	 </div>
	 </div>
     );
   }
}

export default ContactInfo;



// WEBPACK FOOTER //
// ./src/ContactInfo.js